import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installGlobalErrorHandlers } from './utils/errorReporter';

// Before anything renders, so an exception thrown during the first paint is
// still reported. Covers the two paths React's ErrorBoundary cannot see:
// uncaught exceptions outside render, and unhandled promise rejections.
installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker (production only) so the app is installable
// and the shell loads offline. Dev keeps a plain, cache-free experience.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.error('Service worker registration failed:', err);
    });
  });
}
